import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { OutletDescription } from './types'
import type { RootState } from '.'

export interface Market {
  id: number
  title: string
  status: number
  is_for_yandex: number
}

interface State {
  selected: number | null
  list: Market[]
  outletList: OutletDescription[]
}

const selectedItem = localStorage.getItem('marketId')

const selected = selectedItem ? Number(selectedItem) : null

const initialState: State = {
  selected: selected && !isNaN(selected) ? selected : null,
  list: [],
  outletList: [],
}

export const slice = createSlice({
  name: 'market',
  initialState,
  reducers: {
    selectMarket: (state, { payload }: PayloadAction<number>) => {
      state.selected = payload
      localStorage.setItem('marketId', `${payload}`)
    },

    setMarkets: (state, { payload }: PayloadAction<Market[]>) => {
      state.list = payload
    },

    setOutlets: (state, { payload }: PayloadAction<OutletDescription[]>) => {
      state.outletList = payload
    },
  },
})

// --- SELECTORS --- //

export const selectMarket = (state: RootState) => state.market
export const selectSelectedMarket = (state: RootState) => state.market.selected
